import { useTranslation } from 'react-i18next';

import { TextLine } from 'core/elements';
import { Color } from 'theme/enums';

interface IProps {
  onEditPartLineClick?: () => void;
  isEditable?: boolean;
  isDeleted: boolean;
}

export const PartTypeComponentContent = ({
  onEditPartLineClick,
  isEditable = false,
  isDeleted,
}: IProps) => {
  const { t } = useTranslation();

  const props = {
    text: t('messageComponentPartNumberMissing'),
  };

  if (isEditable && onEditPartLineClick) {
    props['onClick'] = onEditPartLineClick;
    props['text'] = t('messageComponentPartNumberEditable');
  }

  if (isDeleted) {
    props['color'] = Color.DANGER;
  }

  return <TextLine {...props} isSubText italic />;
};
